// removed by extract-text-webpack-plugin
module.exports = {"card-title":"CardTitle__card-title___gQcoX"};